<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    Schedule the
    <select
      :value="block_id"
      name="block_id"
      class="form-control"
      @change="handleChange"
    >
      <option value="">Select Event Block</option>
      <option
        v-for="block in config.eventBlocksByType.Source"
        :value="block.id"
      >
        {{ block.name }}
      </option>
    </select>
    block immediately

    <div v-show="showOverlapSection" class="form-group">
      <label>If a block already exists:</label>
      <select :value="blockOverlapAction" name="blockOverlapAction" class="form-control form-control-sm" @change="handleChange">
        <option value="GENERATE_INCIDENT">Generate a software incident</option>
        <option value="ROLLBACK_LOGIC">Rollback the logic</option>
      </select>
    </div>

  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String,
      block_id: [Number, String],
      timing: {
        // In the future we likely want to be able to schedule relative to dates, etc
        default: "immediate"
      },
      blockOverlapAction: {
        type: String,
        default: 'GENERATE_INCIDENT'
      },
    },
    computed: {
      showOverlapSection() {
        if (!this.block_id) {
          return false;
        }

        if (this.config.eventBlocksByType.Source === undefined || this.config.eventBlocksByType.Source[this.block_id] === undefined) {
          return false;
        }

        return this.config.eventBlocksByType.Source[this.block_id]['ignore_overlap'] !== true;
      }
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.block_id) {
          this.errors.block_id = "Please select a block to schedule.";
        }

        if (this.config.eventBlocksByType.Source === undefined || this.config.eventBlocksByType.Source[this.block_id] === undefined) {
          this.errors.blockOverlapAction = "Event block " + this.block_id + " does not exist.";
          return false;
        }

        return Object.keys(this.errors).length === 0;
      }
    },
  };
</script>
